var lib_core = require("lib-core");

var NetlistData = require("./netlistData.js");

var NetData = function () {
    var self = this;

    this.makeObservableTreeNode();

    this.terminals = this.set("terminals", false);

    this.terminals.onRemove("remove Net", function(){
        if (this.size() <= 1 && self.isAlive()) self.remove();
    });

};
lib_core.mixin(NetData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(NetData, "NetData");

module.exports = NetData;

NetData.prototype.mergeNet = function(net) {
    if (net != this) {
        var terminals = net.terminals.copy();
        net.remove();
        this.terminals.addAll(terminals);
    }
};

NetData.prototype.sanityCheck = function() {
    lib_core.ObservableTreeNode.sanityCheck.call(this);
    var self = this;
    self.terminals.forEach(function(logicTerminal) {
        console.assert(logicTerminal.net() === self);
    });
};
